<div class="slider-banner">
    <ngx-slick-carousel class="carousel" 
        #slickModal="slick-carousel" 
        [config]="slideConfig">
        <div ngxSlickItem *ngFor="let data of dataBannerSlider" class="slide">
            <div class="bg-banner">
                <img class="banner-img" [src]="apiAsset + data.picture" [alt]="data.title">
                <div class="det-banner">
                     <div class="px-sm-0 pl-3 pr-4">
                        <h2 class="title" [innerHTML]="data.title"></h2>
                        <div class="py-3 sum" [innerHTML]="data.description"></div>
                    </div>
                    <div class="text-sm-right text-center pr-sm-5">
                        <app-scroll [link]="'#sec-2'"></app-scroll>
                    </div>
                </div>
            </div>
        </div>
    </ngx-slick-carousel>
</div>


